/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Button, FormControlLabel, RadioGroup } from "@mui/material";

export const ConfirmationContainer = styled('div')({
  display: 'flex',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
})

export const CarouselContainer = styled('div')({
  '@media (max-width: 1100px)': {
    display: 'none',
  },
  height: '100vh',
  width: '60%',
})

export const FormContainer = styled('div')({
  '@media (max-width: 1000px)': {
    width: '400px !important',
  },
  height: '100%',
  width: '40%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export const FormWrapper = styled('div')({
  '@media (max-width: 420px)': {
    width: '360px !important',
  },
  width: '530px',
  padding: '5px',
})

export const StyledTitle = styled('p')({
  fontWeight: '400',
  fontSize: '2.375rem !important',
  margin: '0px',
})

export const StyledSubTitle = styled('p')({
  fontSize: '15px',
  margin: '20px 0px',
  letterSpacing: '0.2px',
  lineHeight: '1.5',
})

export const StyledQuestion = styled('p')({
  fontWeight: '600',
  margin: '0',
  fontSize: '15px',
  color: '#252525',
})

export const StyledRadioGroup = styled(RadioGroup)({
  flexDirection: 'row',
  gap: '30px',
  margin: '10px 0px',
})

export const StyledRadioLabel = styled(FormControlLabel)({
  '& .MuiFormControlLabel-label': {
    fontSize: '15px',
    color: '#252525',
  },
  marginLeft: '-9px',
})

export const StyledCaution = styled('p')({
  fontSize: '13px',
  lineHeight: '1.5',
  color: '#8a5300',
  backgroundColor: '#fff6e5',
  borderRadius: '8px',
  padding: '10px 12px',
  margin: '5px 0px 0px 0px',
})

export const StyledNote = styled('p')({
  fontSize: '13px',
  color: '#727272',
  margin: '15px 0px 0px 0px',
})

export const StyledConfirmButton = styled(Button)({
  '&.Mui-disabled': {
    backgroundColor: '#ebebeb',
  },
  '&:hover': {
    backgroundColor: '#001b59',
    borderRadius: '8px',
  },
  textTransform: 'none',
  width: '100%',
  height: '40px',
  backgroundColor: '#395bbd',
  boxShadow: 'none',
  marginTop: '25px',
  color: 'white',
  borderRadius: '8px',
})

export const ButtonContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
})

export const LoaderContainer = styled('div')({
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})
